import React, { useState } from "react";
import { themeStyle, themeStyleDark } from "./Components";
import { useSelector } from "react-redux";
import { Grid } from "@mui/material";
import Button from "@mui/material/Button";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import CopyrightIcon from "@mui/icons-material/Copyright";
import { Up, Down, Left, Right } from "../components/PositionFade";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { useSpring, useSprings, useScroll, animated } from "@react-spring/web";
import { useNavigate } from "react-router";

import {
  LeftInView,
  RightInView,
  UpInView,
  DownInView,
} from "./PositionFadeInView";

const config = {
  duration: 500,
};

export function SpacerV(props) {
  return (
    <div
      style={{
        height: props.height,
        width: "100%",
        backgroundColor: props.background ?? "#111",
      }}
    />
  );
}

export function SpacerH(props) {
  return (
    <div
      style={{
        width: props.width,
        height: "100%",
        backgroundColor: props.background ?? "#111",
      }}
    />
  );
}
export function CardHorizontal(props) {
  const [menuContainer, menuContainerApi] = useSpring(() => ({
    from: { transform: "scale(1)" },
  }));
  const navigate = useNavigate();

  return (
    <a
      href={"/" + props.navigate + "/"}
      style={{ textDecoration: "none", color: "inherit" }}
    >
      <animated.div
        style={{
          padding: "10px",
          paddingLeft: "15px",
          borderRadius: "5px",
          width: "100%",
          backgroundColor: "white",
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          cursor: "pointer",
          transform: "scale(1)",
          ...menuContainer,
        }}
        onClick={() => {
          navigate("/" + props.navigate + "/");
        }}
        onMouseEnter={() => {
          menuContainerApi.start({
            from: {
              transform: "scale(1)",
            },
            to: {
              transform: "scale(1.05)",
            },
          });
        }}
        onMouseLeave={() => {
          menuContainerApi.start({
            from: {
              transform: "scale(1.05)",
            },
            to: {
              transform: "scale(1)",
            },
          });
        }}
      >
        <div style={{ marginTop: "5px" }}>{props.content}</div>
        <div>
          <div
            style={{
              textAlign: "left",
              marginLeft: "15px",
              borderRadius: "25px",
              fontSize: "1.8vh",
              color: "black",
              fontWeight: 600,
            }}
          >
            <h3>{props.title}</h3>
          </div>
          <div
            style={{
              marginTop: "-5px",
              marginLeft: "15px",
              borderRadius: "25px",
              fontSize: "1.8vh",
              color: "#111222",
              textAlign: "left",
            }}
          >
            {props.subtitle}
          </div>
        </div>
      </animated.div>
    </a>
  );
}
export function Hero(props) {
  const state = useSelector((state) => state);
  const timelineDelays = [0, 300, 600];

  return (
    <div
      className="anigrad"
      style={{
        minHeight: "80vh",
        width: "100vw",
        background: props.background,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        paddingTop: "100px",
      }}
    >
      <Grid container>
        <Grid item xs={0} sm={0} md={2} lg={2} xl={2}></Grid>
        <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
          <Grid container spacing={10}>
            <Grid
              item
              md={6}
              xs={12}
              sm={12}
              style={{
                height: "100%",
                width: "100%",
                textAlign: "left",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
                minHeight: "50vh",
              }}
            >
              <Up delay={timelineDelays[0]}>
                <div
                  dangerouslySetInnerHTML={{ __html: props.title }}
                  style={{
                    borderRadius: "25px",
                    fontSize: "52px",
                    color: "white",
                    textAlign: "center",
                    fontWeight: 600,
                    paddingLeft: "15px",

                    paddingTop: state.auth.isMobile ? "50px" : "200px",
                  }}
                ></div>
              </Up>
              <Up delay={timelineDelays[1]}>
                <div
                  dangerouslySetInnerHTML={{ __html: props.subtitle }}
                  style={{
                    borderRadius: "25px",
                    fontSize: "26px",
                    color: "white",
                    paddingLeft: "15px",
                    fontWeight: 500,
                  }}
                ></div>
              </Up>
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
              sm={12}
              style={{
                height: "100%",
                width: "100%",
                textAlign: "left",
              }}
            >
              <Up delay={timelineDelays[2]}>{props.image}</Up>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={0} sm={0} md={2} lg={2} xl={2}></Grid>
      </Grid>
    </div>
  );
}

export function ContentSideBySide(props) {
  const state = useSelector((state) => state);
  const timelineDelays = [0, 300, 600];

  return (
    <div
      style={{
        minHeight: "60vh",
        width: "100vw",
        paddingTop: "75px",
        backgroundColor: props.dark ? "#111" : "white",
        marginTop: state.auth.isMobile ? "-200px" : 0,
      }}
    >
      <Grid container>
        <Grid item xs={0} sm={0} md={1} lg={1} xl={1}></Grid>
        <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
          <Grid container spacing={10}>
            <Grid
              item
              md={7}
              xs={12}
              sm={12}
              style={{
                height: "100%",
                width: "100%",
                textAlign: "left",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "start",
                minHeight: "50vh",
                marginLeft: state.auth.isMobile ? "15px" : "-7.5px",
                paddingRight: state.auth.isMobile ? "10px" : "0px",
              }}
            >
              <RightInView delay={timelineDelays[0]}>
                <div
                  style={{
                    borderRadius: "25px",
                    fontSize: state.auth.isMobile ? "3.2vh" : "4.5vh",
                    color: props.dark ? "white" : "black",
                    fontWeight: 600,
                    lineHeight: state.auth.isMobile ? "5vh" : "7vh",
                    paddingLeft: "15px",
                  }}
                >
                  {props.title}
                </div>
              </RightInView>
              <div
                style={{
                  margin: "15px 0px 50px 15px",
                  width: "60px",
                  height: "5px",
                  backgroundColor: "#1868DD",
                }}
              ></div>
              <RightInView delay={timelineDelays[1]}>
                <div
                  style={{
                    borderRadius: "25px",
                    fontSize: state.auth.isMobile ? "1.8vh" : "2.2vh",
                    color: props.dark ? "white" : "black",
                    paddingLeft: "15px",
                    textAlign: "justify",
                    fontWeight: 500,
                    paddingRight: "2.2vh",
                  }}
                >
                  {props.subtitle}
                </div>
              </RightInView>
            </Grid>
            <Grid
              item
              md={5}
              xs={12}
              sm={12}
              style={{
                height: "100%",
                width: "100%",
                textAlign: "left",
              }}
            >
              <RightInView delay={timelineDelays[2]}>{props.image}</RightInView>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={0} sm={0} md={1} lg={1} xl={1}></Grid>
      </Grid>
    </div>
  );
}

export function ContentSideBySideCustomInv(props) {
  const state = useSelector((state) => state);
  const timelineDelays = [0, 300, 600];

  return (
    <div
      style={{
        paddingTop: "75px",
        background: props.background,
      }}
    >
      <Grid container>
        <Grid item xs={0} sm={0} md={1} lg={1} xl={1}></Grid>
        <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
          <Grid
            container
            spacing={10}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <Grid
              item
              md={6}
              xs={12}
              sm={12}
              style={{
                height: "100%",
                width: "100%",
                textAlign: "left",
              }}
            >
              <RightInView delay={timelineDelays[2]}>{props.image}</RightInView>
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
              sm={12}
              style={{
                height: "100%",
                width: "100%",
                textAlign: "left",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "start",
                minHeight: "50vh",
              }}
            >
              <RightInView delay={timelineDelays[0]}>
                <div
                  style={{
                    borderRadius: "25px",
                    fontSize:
                      props.titleFontSize == null
                        ? "60px"
                        : props.titleFontSize,
                    color:
                      props.titleColor == null ? "black" : props.titleColor,
                    fontWeight: 600,
                    lineHeight: "60px",
                    paddingLeft: "30px",
                  }}
                >
                  <h3>{props.title}</h3>
                </div>
              </RightInView>
              <div
                style={{
                  margin: "15px 0px 50px 30px",
                  width: "60px",
                  height: "5px",
                  backgroundColor: "#1868DD",
                }}
              ></div>
              <RightInView delay={timelineDelays[1]}>
                <div
                  style={{
                    fontWeight: 500,
                    borderRadius: "25px",
                    fontSize:
                      props.subtitleFontSize == null
                        ? "1.8vh"
                        : props.subtitleFontSize,
                    color:
                      props.subtitleColor == null
                        ? "grey"
                        : props.subtitleColor,
                    paddingLeft: "15px",
                  }}
                >
                  {props.subtitle}
                </div>
              </RightInView>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={0} sm={0} md={1} lg={1} xl={1}></Grid>
      </Grid>
    </div>
  );
}

export function ContentSideBySideCustom(props) {
  const state = useSelector((state) => state);
  const timelineDelays = [0, 100, 300];

  return (
    <div
      style={{
        paddingTop: "75px",
        background: props.background,
      }}
    >
      <Grid container>
        <Grid item xs={0} sm={0} md={1} lg={1} xl={1}></Grid>
        <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
          <Grid
            container
            spacing={10}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <Grid
              item
              md={6}
              xs={12}
              sm={12}
              style={{
                height: "100%",
                width: "80%",
                textAlign: "left",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "start",
                minHeight: "50vh",
              }}
            >
              <RightInView delay={timelineDelays[0]}>
                <div
                  style={{
                    borderRadius: "25px",
                    fontSize:
                      props.titleFontSize == null
                        ? "60px"
                        : props.titleFontSize,
                    color:
                      props.titleColor == null ? "black" : props.titleColor,
                    fontWeight: 600,
                    lineHeight: state.auth.isMobile ? "5vh" : "7vh",
                    paddingLeft: "5px",
                  }}
                >
                  <h3>{props.title}</h3>
                </div>
              </RightInView>
              <div
                style={{
                  margin: "15px 0px 50px 5px",
                  width: "60px",
                  height: "5px",
                  backgroundColor: "#1868DD",
                }}
              ></div>
              <RightInView delay={timelineDelays[1]}>
                <div
                  style={{
                    borderRadius: "25px",
                    fontSize:
                      props.subtitleFontSize == null
                        ? "1.8vh"
                        : props.subtitleFontSize,
                    color:
                      props.subtitleColor == null
                        ? "grey"
                        : props.subtitleColor,
                    paddingLeft: "5px",
                    textAlign: "justify",
                    fontWeight: 500,
                  }}
                >
                  {props.subtitle}
                </div>
              </RightInView>
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
              sm={12}
              style={{
                height: "100%",
                width: "80%",
                textAlign: "left",
              }}
            >
              <RightInView delay={timelineDelays[2]}>{props.image}</RightInView>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={0} sm={0} md={1} lg={1} xl={1}></Grid>
      </Grid>
    </div>
  );
}

export function ContentSideBySideCustomNoAnim(props) {
  const state = useSelector((state) => state);
  const timelineDelays = [0, 300, 600];

  return (
    <div
      style={{
        paddingTop: "75px",
        background: props.background,
      }}
    >
      <Grid container>
        <Grid item xs={0} sm={0} md={1} lg={1} xl={1}></Grid>
        <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
          <Grid
            container
            spacing={10}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <Grid
              item
              md={6}
              xs={12}
              sm={12}
              style={{
                height: "100%",
                width: "80%",
                textAlign: "left",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "start",
                minHeight: "50vh",
              }}
            >
              <div
                style={{
                  borderRadius: "25px",
                  fontSize:
                    props.titleFontSize == null ? "60px" : props.titleFontSize,
                  color: props.titleColor == null ? "black" : props.titleColor,
                  fontWeight: 600,
                  lineHeight: "40px",
                  paddingLeft: "15px",
                }}
              >
                <h3>{props.title}</h3>
              </div>
              <div
                style={{
                  margin: "15px 0px 50px 15px",
                  width: "60px",
                  height: "5px",
                  backgroundColor: "#1868DD",
                  paddingLeft: "15px",
                }}
              ></div>
              <div
                dangerouslySetInnerHTML={{ __html: props.subtitle }}
                style={{
                  borderRadius: "25px",
                  fontSize:
                    props.subtitleFontSize == null
                      ? "1.8vh"
                      : props.subtitleFontSize,
                  color:
                    props.subtitleColor == null ? "grey" : props.subtitleColor,
                  paddingLeft: "15px",
                  textAlign: "justify",
                  fontWeight: 500,
                  paddingRight: state.auth.isMobile ? "10px" : "0px",
                }}
              ></div>
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
              sm={12}
              style={{
                height: "100%",
                width: "80%",
                textAlign: "left",
                paddingRight: state.auth.isMobile ? "10px" : "0px",
              }}
            >
              {props.image}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={0} sm={0} md={1} lg={1} xl={1}></Grid>
      </Grid>
    </div>
  );
}

export function ContentSideBySideInv(props) {
  const state = useSelector((state) => state);
  const timelineDelays = [0, 300, 600];

  return (
    <div
      style={{
        minHeight: "60vh",
        width: "100vw",
        paddingTop: state.auth.isMobile ? "0px" : "75px",
        backgroundColor: props.dark ? "#111" : "white",
      }}
    >
      <Grid container>
        <Grid item xs={0} sm={0} md={1} lg={1} xl={1}></Grid>
        <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
          <Grid container spacing={5}>
            <Grid
              item
              md={6}
              xs={12}
              sm={12}
              style={{
                height: "100%",
                width: "100%",
                textAlign: "left",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "start",
                minHeight: "50vh",
              }}
            >
              <RightInView delay={timelineDelays[0]}>{props.image}</RightInView>
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
              sm={12}
              style={{
                height: "100%",
                width: "100%",
                textAlign: "left",
              }}
            >
              <RightInView delay={timelineDelays[0]}>
                <div
                  style={{
                    borderRadius: "25px",
                    fontSize: state.auth.isMobile ? "3.2vh" : "4.5vh",
                    color: props.dark ? "white" : "black",
                    fontWeight: 600,
                    lineHeight: state.auth.isMobile ? "5vh" : "7vh",
                    paddingLeft: "15px",
                  }}
                >
                  {props.title}
                </div>
              </RightInView>
              <div
                style={{
                  margin: "15px 0px 50px 15px",
                  width: "60px",
                  height: "5px",
                  backgroundColor: "#1868DD",
                }}
              ></div>
              <RightInView delay={timelineDelays[1]}>
                {(typeof props.subtitle).toString() == "object" ? (
                  <div
                    style={{
                      borderRadius: "25px",
                      fontSize: state.auth.isMobile ? "1.8vh" : "2.2vh",
                      color: props.dark ? "white" : "black",
                      paddingLeft: "15px",
                      textAlign: "justify",
                      fontWeight: 500,
                      paddingRight: "2.2vh",
                    }}
                  >
                    {props.subtitle}
                  </div>
                ) : (
                  <div
                    dangerouslySetInnerHTML={{ __html: props.subtitle }}
                    style={{
                      borderRadius: "25px",
                      fontSize: state.auth.isMobile ? "1.8vh" : "2.2vh",
                      color: props.dark ? "white" : "black",
                      paddingLeft: "15px",
                      textAlign: "justify",
                      fontWeight: 500,
                      paddingRight: "2.2vh",
                    }}
                  ></div>
                )}
              </RightInView>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={0} sm={0} md={1} lg={1} xl={1}></Grid>
      </Grid>
    </div>
  );
}

export function FeatureCard(props) {
  const state = useSelector((state) => state);

  const [zoom, zoomApi] = useSpring(() => ({
    from: { transform: "scale(1)" },
  }));

  return (
    <animated.div
      onMouseEnter={() => {
        zoomApi.start({
          from: {
            transform: "scale(1)",
          },
          to: {
            transform: "scale(1.05)",
          },
        });
      }}
      onMouseLeave={() => {
        zoomApi.start({
          from: {
            transform: "scale(1.05)",
          },
          to: {
            transform: "scale(1)",
          },
        });
      }}
      style={{
        cursor: "pointer",
        padding: "25px",
        paddingTop: "15px",
        borderRadius: "10px",
        width: state.auth.isMobile ? "92%" : "100%",
        height: "100%",
        backgroundImage: props.gradient,
        justifyContent: "space-between",
        alignItems: "flex-start",
        display: "flex",
        color: "#ddd",
        minHeight: props.minHeight == null ? "45vh" : props.minHeight,
        ...zoom,
      }}
    >
      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div>{props.icon}</div>

        <div
          style={{
            marginTop: "1.2vw",
            color: "white",
            textAlign: "left",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            fontSize: "18px",
          }}
        >
          <div
            style={{
              display: "flex",
              color: "white",
              fontWeight: 600,
              fontSize: state.auth.isMobile
                ? state.auth.isTablet
                  ? "5.2vw"
                  : "22px"
                : "2.2vw",
              marginTop: "15px",
              marginBottom: state.auth.isMobile
                ? state.auth.isTablet
                  ? "6.2vw"
                  : "22px"
                : "3vw",
            }}
          >
            <h3>{props.title}</h3>
          </div>
          {props.text}
        </div>
      </div>
    </animated.div>
  );
}

export function FeatureCardSmall(props) {
  const state = useSelector((state) => state);

  const [zoom, zoomApi] = useSpring(() => ({
    from: { transform: "scale(1)" },
  }));

  return (
    <animated.div
      onMouseEnter={() => {
        zoomApi.start({
          from: {
            transform: "scale(1)",
          },
          to: {
            transform: "scale(1.05)",
          },
        });
      }}
      onMouseLeave={() => {
        zoomApi.start({
          from: {
            transform: "scale(1.05)",
          },
          to: {
            transform: "scale(1)",
          },
        });
      }}
      style={{
        cursor: "pointer",
        padding: "25px",
        paddingTop: "15px",
        borderRadius: "10px",
        width: "100%",
        height: "100%",
        backgroundImage: props.gradient,
        justifyContent: "space-between",
        alignItems: "flex-start",
        display: "flex",
        ...zoom,
      }}
    >
      <div>
        {props.icon}
        <div
          style={{
            color: "white",
            textAlign: "left",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            fontSize: "18px",
          }}
        >
          <div
            style={{
              display: "flex",
              color: "white",
              fontWeight: 600,
              fontSize: state.auth.isMobile ? "1.8vh" : "2.2vh",
              marginTop: "15px",
            }}
          >
            <h3>{props.title}</h3>
          </div>
        </div>
      </div>
    </animated.div>
  );
}

export function ThreeSideBySide(props) {
  const state = useSelector((state) => state);
  const timelineDelays = [0, 300, 600];

  return (
    <div
      className="anigrad"
      style={{
        width: "100vw",
        background: props.background == null ? "none" : props.background,
        paddingBottom: "100px",
      }}
    >
      <div
        style={{
          paddingTop: "50px",
          fontSize: state.auth.isMobile ? "30px" : "4.4vh",
          color: "white",
          zIndex: 999,
          fontWeight: "bold",
        }}
      >
        <h2>{props.hero}</h2>
      </div>
      <br />
      <Grid container>
        <Grid item xs={0} sm={0} md={1} lg={1} xl={1}></Grid>
        <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
          <Grid
            container
            spacing={props.spacing == null ? 10 : props.spacing}
            justifyContent={"flex-start"}
          >
            <Grid
              item
              md={4}
              xs={12}
              sm={12}
              style={{
                height: "100%",
                width: "100%",
                textAlign: "left",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "start",
                minHeight: "50vh",
                marginLeft: state.auth.isMobile ? "15px" : "-7.5px",
              }}
            >
              <UpInView delay={timelineDelays[0]}>
                <img
                  style={{
                    width: "100%",
                    maxHeight: "500px",
                    maxWidth: "500px",
                    objectFit: "cover",
                  }}
                  src={props.image1}
                ></img>
              </UpInView>

              <UpInView delay={timelineDelays[1]}>
                <div
                  style={{
                    marginTop: "50px",
                    textAlign: "center",
                    borderRadius: "25px",
                    fontSize: "26px",
                    color: "black",
                    fontWeight: 600,
                    lineHeight: "40px",
                  }}
                >
                  {props.title1}
                </div>
              </UpInView>
              <UpInView delay={timelineDelays[2]}>
                <div
                  style={{
                    borderRadius: "25px",
                    fontSize: "1.8vh",
                    color: "black",
                    paddingLeft: "15px",
                  }}
                >
                  {props.subtitle1}
                </div>
              </UpInView>
            </Grid>
            <Grid
              item
              md={4}
              xs={12}
              sm={12}
              style={{
                height: "100%",
                width: "100%",
                textAlign: "left",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "start",
                minHeight: "50vh",
                marginLeft: state.auth.isMobile ? "15px" : "-7.5px",
              }}
            >
              <UpInView delay={timelineDelays[0]}>
                <img
                  style={{
                    width: "100%",
                    maxHeight: "500px",
                    maxWidth: "500px",
                    objectFit: "cover",
                  }}
                  src={props.image2}
                ></img>
              </UpInView>

              <UpInView delay={timelineDelays[1]}>
                <div
                  style={{
                    marginTop: "50px",
                    textAlign: "center",
                    borderRadius: "25px",
                    fontSize: "26px",
                    color: "black",
                    fontWeight: 600,
                    lineHeight: "40px",
                  }}
                >
                  {props.title2}
                </div>
              </UpInView>
              <UpInView delay={timelineDelays[2]}>
                <div
                  style={{
                    borderRadius: "25px",
                    fontSize: "1.8vh",
                    color: "black",
                    paddingLeft: "15px",
                  }}
                >
                  {props.subtitle2}
                </div>
              </UpInView>
            </Grid>
            <Grid
              item
              md={4}
              xs={12}
              sm={12}
              style={{
                height: "100%",
                width: "100%",
                textAlign: "left",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "start",
                minHeight: "50vh",
                marginLeft: state.auth.isMobile ? "15px" : "-7.5px",
              }}
            >
              <UpInView delay={timelineDelays[0]}>
                <img
                  style={{
                    width: "100%",
                    maxHeight: "500px",
                    maxWidth: "500px",
                    objectFit: "cover",
                  }}
                  src={props.image2}
                ></img>
              </UpInView>

              <UpInView delay={timelineDelays[1]}>
                <div
                  style={{
                    marginTop: "50px",
                    textAlign: "center",
                    borderRadius: "25px",
                    fontSize: "26px",
                    color: "black",
                    fontWeight: 600,
                    lineHeight: "40px",
                  }}
                >
                  {props.title3}
                </div>
              </UpInView>
              <UpInView delay={timelineDelays[2]}>
                <div
                  style={{
                    borderRadius: "25px",
                    fontSize: "1.8vh",
                    color: "black",
                    paddingLeft: "15px",
                  }}
                >
                  {props.subtitle3}
                </div>
              </UpInView>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={0} sm={0} md={1} lg={1} xl={1}></Grid>
      </Grid>
    </div>
  );
}

export function Gallery(props) {
  const state = useSelector((state) => state);
  const timelineDelays = [0, 300, 600];
  const [activeIndex, setActiveIndex] = useState(240);

  const zoomIns = useSprings(
    props.gallery.length,
    props.gallery.map((prop, index) => ({
      from: { transform: "scale(1)" },
      to: { transform: activeIndex == index ? "scale(1.05)" : "scale(1)" },
    }))
  );

  return (
    <div
      style={{
        width: "100vw",
        paddingTop: "75px",
        background: props.background ?? "#111",
      }}
    >
      <Grid container>
        <Grid item xs={0} sm={0} md={2} lg={2} xl={2}></Grid>
        <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
          <Grid container spacing={5}>
            {props.gallery.map((gal1, index) => (
              <Grid
                item
                md={4}
                xs={12}
                sm={12}
                style={{
                  height: "100%",
                  width: "100%",
                  textAlign: "left",
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  alignItems: "start",
                  minHeight: "50vh",
                }}
              >
                <UpInView delay={timelineDelays[index]}>
                  <animated.div
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                      ...zoomIns[index],
                    }}
                    onMouseEnter={() => {
                      setActiveIndex(index);
                    }}
                    onMouseLeave={() => {
                      setActiveIndex(240);
                    }}
                  >
                    <div
                      alt="Norway"
                      style={{
                        height: "50vh",
                        width: "100%",
                        borderRadius: "15px",
                        backgroundPosition: "center",
                        background:
                          "linear-gradient(0deg, rgba(0,0,0,0.9), rgba(2, 77, 194, 0.0), rgba(2, 77, 194, 0.0)), url('" +
                          gal1["image"] +
                          "')",
                        backgroundSize: "cover",
                        backgroundRepeat: "none",
                      }}
                    />
                    <div
                      style={{
                        borderTopRightRadius: "50px",
                        padding: "1.8vh",
                        position: "absolute",
                        textAlign: "left",
                        bottom: 10,
                      }}
                    >
                      <div
                        style={{
                          fontSize: "25px",
                          color: "white",
                          fontWeight: 600,
                        }}
                      >
                        {gal1["title"]}
                      </div>
                      <div
                        style={{
                          fontSize: "1.8vh",
                          color: "white",
                          fontWeight: "lighter",
                        }}
                      >
                        {gal1["subtitle"]}
                      </div>
                    </div>
                  </animated.div>
                </UpInView>
              </Grid>
            ))}
          </Grid>
        </Grid>
        <Grid item xs={0} sm={0} md={2} lg={2} xl={2}></Grid>
      </Grid>
    </div>
  );
}

export function Stats(props) {
  const state = useSelector((state) => state);
  const timelineDelays = [0, 300, 600];
  const [activeIndex, setActiveIndex] = useState(240);

  const zoomIns = useSprings(
    4,
    [1, 2, 3, 4].map((prop, index) => ({
      from: { transform: "scale(1)" },
      to: { transform: activeIndex == index ? "scale(1.05)" : "scale(1)" },
    }))
  );

  return (
    <div
      style={{
        width: "100vw",
        paddingTop: "75px",
        background: "#111",
      }}
    >
      <Grid container>
        <Grid item xs={0} sm={0} md={1} lg={1} xl={1}></Grid>
        <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
          <Grid container spacing={5} style={{ justifyContent: "center" }}>
            <Grid
              item
              md={4}
              lg={4}
              xl={12 / 5}
              xs={12}
              sm={12}
              style={{
                height: "100%",
                width: "100%",
                textAlign: "left",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "start",
              }}
            >
              <UpInView delay={timelineDelays[0]}>
                <animated.div
                  className={"anigrad"}
                  onMouseEnter={() => {
                    setActiveIndex(0);
                  }}
                  onMouseLeave={() => {
                    setActiveIndex(10);
                  }}
                  style={{
                    width: state.auth.isMobile ? "90%" : "100%",
                    marginLeft: "2.2vh",
                    cursor: "pointer",
                    paddingTop: "15px",
                    padding: "25px",
                    borderRadius: "10px",
                    minHeight: "27.5vh",
                    height: "100%",
                    backgroundImage: props.gradient,
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    display: "flex",
                    color: "#ddd",
                    borderRadius: "15px",
                    border: "2px solid grey",
                  }}
                >
                  <div
                    style={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "42px",
                        color: "white",
                      }}
                    >
                      $12 Million
                    </div>

                    <div
                      style={{
                        color: "white",
                        textAlign: "left",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        fontSize: "18px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          color: "white",
                          fontWeight: 600,
                          fontSize: state.auth.isMobile ? "1.8vh" : "2.2vh",
                          marginTop: "15px",
                        }}
                      >
                        SPEND
                      </div>
                      For Clients
                    </div>
                  </div>
                </animated.div>
              </UpInView>
            </Grid>
            <Grid
              item
              md={4}
              lg={4}
              xl={12 / 5}
              xs={12}
              sm={12}
              style={{
                height: "100%",
                width: "100%",
                textAlign: "left",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "start",
              }}
            >
              <UpInView delay={timelineDelays[0]}>
                <animated.div
                  className={"anigrad"}
                  onMouseEnter={() => {
                    setActiveIndex(0);
                  }}
                  onMouseLeave={() => {
                    setActiveIndex(10);
                  }}
                  style={{
                    width: state.auth.isMobile ? "90%" : "100%",
                    marginLeft: "2.2vh",
                    cursor: "pointer",
                    paddingTop: "15px",
                    padding: "25px",
                    borderRadius: "10px",
                    minHeight: "27.5vh",
                    height: "100%",
                    backgroundImage: props.gradient,
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    display: "flex",
                    color: "#ddd",
                    borderRadius: "15px",
                    border: "2px solid grey",
                  }}
                >
                  <div
                    style={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "42px",
                        color: "white",
                      }}
                    >
                      $54 Million
                    </div>

                    <div
                      style={{
                        color: "white",
                        textAlign: "left",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        fontSize: "18px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          color: "white",
                          fontWeight: 600,
                          fontSize: state.auth.isMobile ? "1.8vh" : "2.2vh",
                          marginTop: "15px",
                        }}
                      >
                        REVENUE
                      </div>
                      For Clients
                    </div>
                  </div>
                </animated.div>
              </UpInView>
            </Grid>
            <Grid
              item
              md={4}
              lg={4}
              xl={12 / 5}
              xs={12}
              sm={12}
              style={{
                height: "100%",
                width: "100%",
                textAlign: "left",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "start",
              }}
            >
              <UpInView delay={timelineDelays[0]}>
                <animated.div
                  className={"anigrad"}
                  onMouseEnter={() => {
                    setActiveIndex(0);
                  }}
                  onMouseLeave={() => {
                    setActiveIndex(10);
                  }}
                  style={{
                    width: state.auth.isMobile ? "90%" : "100%",
                    marginLeft: "2.2vh",
                    cursor: "pointer",
                    paddingTop: "15px",
                    padding: "25px",
                    borderRadius: "10px",
                    minHeight: "27.5vh",
                    height: "100%",
                    backgroundImage: props.gradient,
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    display: "flex",
                    color: "#ddd",
                    borderRadius: "15px",
                    border: "2px solid grey",
                  }}
                >
                  <div
                    style={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "42px",
                        color: "white",
                      }}
                    >
                      $4.5 Return
                    </div>

                    <div
                      style={{
                        color: "white",
                        textAlign: "left",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        fontSize: "18px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          color: "white",
                          fontWeight: 600,
                          fontSize: state.auth.isMobile ? "1.8vh" : "2.2vh",
                          marginTop: "15px",
                        }}
                      >
                        ROI
                      </div>
                      For Clients
                    </div>
                  </div>
                </animated.div>
              </UpInView>
            </Grid>
            <Grid
              item
              md={4}
              lg={4}
              xl={12 / 5}
              xs={12}
              sm={12}
              style={{
                height: "100%",
                width: "100%",
                textAlign: "left",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "start",
              }}
            >
              <UpInView delay={timelineDelays[0]}>
                <animated.div
                  className={"anigrad"}
                  onMouseEnter={() => {
                    setActiveIndex(0);
                  }}
                  onMouseLeave={() => {
                    setActiveIndex(10);
                  }}
                  style={{
                    width: state.auth.isMobile ? "90%" : "100%",
                    marginLeft: "2.2vh",
                    cursor: "pointer",
                    paddingTop: "15px",
                    padding: "25px",
                    borderRadius: "10px",
                    minHeight: "27.5vh",
                    height: "100%",
                    backgroundImage: props.gradient,
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    display: "flex",
                    color: "#ddd",
                    borderRadius: "15px",
                    border: "2px solid grey",
                  }}
                >
                  <div
                    style={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "42px",
                        color: "white",
                      }}
                    >
                      1.4 Million
                    </div>

                    <div
                      style={{
                        color: "white",
                        textAlign: "left",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        fontSize: "18px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          color: "white",
                          fontWeight: 600,
                          fontSize: state.auth.isMobile ? "1.8vh" : "2.2vh",
                          marginTop: "15px",
                        }}
                      >
                        TOTAL LEADS
                      </div>
                      Our Presence
                    </div>
                  </div>
                </animated.div>
              </UpInView>
            </Grid>
            <Grid
              item
              md={4}
              lg={4}
              xl={12 / 5}
              xs={12}
              sm={12}
              style={{
                height: "100%",
                width: "100%",
                textAlign: "left",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "start",
              }}
            >
              <UpInView delay={timelineDelays[0]}>
                <animated.div
                  className={"anigrad"}
                  onMouseEnter={() => {
                    setActiveIndex(0);
                  }}
                  onMouseLeave={() => {
                    setActiveIndex(10);
                  }}
                  style={{
                    width: state.auth.isMobile ? "90%" : "100%",
                    marginLeft: "2.2vh",
                    cursor: "pointer",
                    paddingTop: "15px",
                    padding: "25px",
                    borderRadius: "10px",
                    minHeight: "27.5vh",
                    height: "100%",
                    backgroundImage: props.gradient,
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    display: "flex",
                    color: "#ddd",
                    borderRadius: "15px",
                    border: "2px solid grey",
                  }}
                >
                  <div
                    style={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "42px",
                        color: "white",
                      }}
                    >
                      $11.5 in CPA
                    </div>

                    <div
                      style={{
                        color: "white",
                        textAlign: "left",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        fontSize: "18px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          color: "white",
                          fontWeight: 600,
                          fontSize: state.auth.isMobile ? "1.8vh" : "2.2vh",
                          marginTop: "15px",
                        }}
                      >
                        CPA
                      </div>
                      Our Experience
                    </div>
                  </div>
                </animated.div>
              </UpInView>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={0} sm={0} md={1} lg={1} xl={1}></Grid>
      </Grid>

      <div
        style={{
          width: "100vw",
          backgroundColor: props.invert ? "white" : "#111",
          marginTop: "100px",
        }}
      >
        <marquee>
          <div
            style={{
              display: "flex",
              fontSize: "3vh",
              color: props.invert ? "black" : "white",
              display: "flex",
            }}
          >
            In 2024, we've spent $12M across lead gen and e-commerce, marking
            strong YoY growth. Our e-commerce campaigns delivered 4.5x ROAS,
            generating $54M in revenue from leads.
          </div>
        </marquee>
      </div>
    </div>
  );
}

export function News(props) {
  const state = useSelector((state) => state);
  const timelineDelays = [0, 300, 600];
  const [activeIndex, setActiveIndex] = useState(240);

  const zoomIns = useSprings(
    props.gallery.length,
    props.gallery.map((prop, index) => ({
      from: { transform: "translate(0px, 0px)" },
      to: {
        transform:
          activeIndex == index
            ? "translate(0px, -15px)"
            : "translate(0px, 0px)",
      },
    }))
  );

  return (
    <div
      style={{
        width: "100vw",
        paddingTop: "75px",
        background: "white",
      }}
    >
      <Grid container>
        <Grid item xs={0} sm={0} md={1} lg={1} xl={1}></Grid>
        <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
          <Grid container spacing={5}>
            {props.gallery.map((gal1, index) => (
              <Grid
                item
                md={3}
                xs={12}
                sm={12}
                style={{
                  height: "100%",
                  width: "100%",
                  textAlign: "left",
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  alignItems: "start",
                  minHeight: "40vh",
                  borderRadius: "15px",
                }}
              >
                <UpInView delay={timelineDelays[index]}>
                  <animated.div
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                      ...zoomIns[index],
                    }}
                    onMouseEnter={() => {
                      setActiveIndex(index);
                    }}
                    onMouseLeave={() => {
                      setActiveIndex(240);
                    }}
                  >
                    <div
                      alt="Norway"
                      style={{
                        height: "40vh",
                        width: "100%",
                        backgroundPosition: "center",
                        background:
                          "linear-gradient(-180deg, rgba(0,0,0,0.9), rgba(0, 0,0, 0.4), rgba(2, 77, 194, 0.0)), url('" +
                          gal1["image"] +
                          "')",
                        backgroundSize: "cover",
                        backgroundRepeat: "none",
                        borderRadius: "15px",
                      }}
                    />
                    <div
                      style={{
                        borderTopRightRadius: "50px",
                        padding: "1.8vh",
                        position: "absolute",
                        textAlign: "left",
                        top: 10,
                      }}
                    >
                      <div
                        style={{
                          fontSize: "25px",
                          color: "white",
                          fontWeight: 600,
                        }}
                      >
                        {gal1["title"]}
                      </div>
                      <div
                        style={{
                          fontSize: "1.8vh",
                          color: "white",
                          fontWeight: "normal",
                        }}
                      >
                        {gal1["subtitle"]}
                      </div>
                    </div>
                  </animated.div>
                </UpInView>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
